import { Guard, type GuardRun } from '../utils/Guard';
import { stateGnosisPayToken } from '$states/gnosisPayToken.svelte';

export class RequireGnosisPayTokenForSubpages extends Guard implements GuardRun {
  run() {
    if (this.target.includes('/card/') && !stateGnosisPayToken.current) {
      return this.redirectTo('/card');
    }
  }
}
